const breakdownLocaleTag = (localeTag) => {
  if (Intl == null ? void 0 : Intl.Locale) {
    try {
      const locale = new Intl.Locale(localeTag);
      return {
        language: locale.language,
        script: locale.script,
        region: locale.region
      };
    } catch (e) {
    }
  }
  const splitLocaleTag = localeTag.split("-");
  return { language: splitLocaleTag[0], region: splitLocaleTag[1] };
};
const getBestFitLocaleTag = (localeTag, availableLocaleKeys) => {
  var _a;
  const localeBreakdown = breakdownLocaleTag(localeTag);
  const regex = new RegExp(`^${String(localeBreakdown.language)}(-${String(localeBreakdown.script)})?(-${String(localeBreakdown.region)})?$`);
  const matchingLocales = availableLocaleKeys.filter((localeKey) => {
    return regex.test(localeKey);
  }).sort((a, b) => {
    return a.length > b.length ? -1 : 1;
  });
  return (_a = matchingLocales[0]) != null ? _a : localeTag;
};

export { getBestFitLocaleTag };
